import { render, staticRenderFns } from "./CompanyAccesses.vue?vue&type=template&id=4e793fce&"
import script from "./CompanyAccesses.vue?vue&type=script&lang=js&"
export * from "./CompanyAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports